import OfferMediumsDao from "../infrastructure/dao/OfferMediumsDao";
import { NumberishId } from "../model/type";

const getAllMediumIds = (dao: OfferMediumsDao): GetAllMediumIds<true> => offerId => {
    return dao.findAllMediumIds(offerId)
}
export default getAllMediumIds;

export type GetAllMediumIds<UseOfferId extends boolean = false> =
    UseOfferId extends true
        ? (offerId: string) => Promise<NumberishId[]>
        : () => Promise<NumberishId[]>